import React, { Suspense } from 'react';
import EditContainer from "./EditContainer";

const EditEvaluation = (props) => {
    return (
        <EditContainer {...props} />
    );
};

export default EditEvaluation;